import { render, staticRenderFns } from "./GamesNicheIcon.vue?vue&type=template&id=a1adfb36&scoped=true"
import script from "./GamesNicheIcon.vue?vue&type=script&lang=js"
export * from "./GamesNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1adfb36",
  null
  
)

export default component.exports